// @flow

import React from "react";
import { connect } from "react-redux";
import { Route, Redirect } from "react-router-dom";

type Props = {
	component: Function,
	authorized: boolean
};

type StateProps = {
	authorized: boolean,
  lang: string
};

const PublicRoute = ({ component: Child, authorized, userId, lang, ...rest }: Props) => (
  <Route
    {...rest}
    // eslint-disable-next-line
    render={props => (rest.location.search.length>0 && [`/${lang}/login/`, `/login/`, `/auth/`].includes(rest.location.pathname) || !authorized && !localStorage.access_token && ["/en/", "/es/", "/pt/", "/zh/"].includes(rest.location.pathname)
      ? <Child {...props} />
      : <Redirect to={`/`} />
    )}
  />
);

const mapStateToProps = (state): StateProps => ({
  authorized: state.user.authorized,
  userId:     state.user.info && state.user.info.userId,
  lang:       state.user.lang.toLowerCase()
});

export default connect(mapStateToProps)(PublicRoute);



// WEBPACK FOOTER //
// ./src/components/routes/PublicRoute.js